module.exports = __webpack_public_path__ + "img/product-teacher-ckzy-01.58306071.png";